<template>
  <li>
    <div class="h_cover_wrap">
      <router-link
        :to="{
          name: `book_detail`,
          params: { id: book.bookCd || book.id, orderId: book.orderId }
        }"
        class="thum_wrap"
      >
        <img :src="book.img" :alt="book.title + ` 책 표지`" />
      </router-link>
    </div>
    <div class="info_wrap">
      <router-link
        :to="{
          name: `book_detail`,
          params: { id: book.bookCd || book.id, orderId: book.orderId }
        }"
      >
        <h3 class="meta_title">{{ book.title }}</h3>
      </router-link>
      <p v-if="displaySub" class="row">
        <span v-if="book.author" class="meta_author">{{ book.author }}</span>
        <span
          v-if="book.date"
          class="meta_date"
          :class="{ hidden: !landscape }"
          >{{ book.date }}</span
        >
        <span class="iconbox" :class="{ hidden: !landscape }">
          <span :class="{ active: hasEbook }" class="meta_editer epub">
            <span class="an_i"></span>
            <span class="an_t">{{ $t('base.basebook.ebook') }}</span>
          </span>
        </span>
      </p>

      <p :class="!landscape ? 'hidden' : ''" class="meta_dscript">
        <router-link
          :to="{
            name: `${library ? 'library_' : ''}book_detail`,
            params: { id: book.bookCd || book.id, orderId: book.orderId }
          }"
        >
          {{ book.Nm }} 상세보기
        </router-link>
      </p>
      <dl v-if="displayPrice" class="meta_price">
        <!-- eslint-disable-next-line -->
        <div v-if="paperPrice" style="display: flex;">
          <dt>{{ $t('base.basebook.219') }}</dt>
          <!-- Formatted Paper Price -->
          <dd>
            <vue-intl-numberformat
              locale="ko-KR"
              format-style="currency"
              :currency="getCurrency.currency"
              :number="paperPrice"
            />
          </dd>
        </div>
        <!-- eslint-disable-next-line -->
        <div v-if="ebookPrice" style="display: flex;">
          <dt>{{ $t('base.basebook.5066') }}</dt>
          <!-- Formatted eBook Price -->
          <dd>
            <vue-intl-numberformat
              locale="ko-KR"
              format-style="currency"
              :currency="getCurrency.currency"
              :number="ebookPrice"
            />
          </dd>
        </div>
      </dl>
    </div>
  </li>
</template>

<script>
// import StarRating from 'vue-star-rating'
import { mapGetters } from 'vuex'
import { UI_SELECT_BOOK, UI_UNSELECT_BOOK } from '@/store/types'

export default {
  name: 'BaseBook',

  props: {
    book: {
      type: Object,
      required: true
    },
    landscape: {
      type: Boolean,
      default: false
    },
    library: {
      type: Boolean,
      default: false
    },
    displayPrice: {
      type: Boolean,
      default: false
    },
    displaySub: {
      type: Boolean,
      default: true
    },
    displayRating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: false,
      // For star-rating package
      starSize: 16,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      isPc: false,
      isMobile: false
    }
  },
  mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
  },
  computed: {
    ...mapGetters(['isMoveBookModeEnabled', 'getCurrency']),
    isFree() {
      if (this.book.ebookOrders && this.book.ebookOrders.isFreeOrder)
        return true
      return false
    },
    hasEbook() {
      return this.book.buyTp ? this.book.buyTp.ebook : false
    },
    paperPrice() {
      if (
        this.book.bookPrice &&
        this.book.bookPrice.paperbook &&
        this.book.bookPrice.paperbook.salePrice
      ) {
        const lang = localStorage.getItem('lang')
          ? this.getCurrency.currency
          : 'KRW'

        return this.book.bookPrice.paperbook.currencies.find(
          (e) => e.currencyTp === lang
        ).salePrice
      }
      return 0
    },
    ebookPrice() {
      if (
        this.book.bookPrice &&
        this.book.bookPrice.ebook &&
        this.book.bookPrice.ebook.salePrice
      ) {
        const lang = localStorage.getItem('lang')
          ? this.getCurrency.currency
          : 'KRW'

        return this.book.bookPrice.ebook.currencies.find(
          (e) => e.currencyTp === lang
        ).salePrice
      }
      return 0
    },
    ratingScore() {
      if (this.book.rating) {
        return parseFloat(this.book.rating.average || 0)
      }

      if (this.book.rate) {
        return parseFloat(this.book.rate.average || 0)
      }
      return 0
    },
    ratingCount() {
      if (this.book.rating) {
        return parseFloat(this.book.rating.rateCount || 0)
      }

      if (this.book.rate) {
        return parseFloat(this.book.rate.rateCount || 0)
      }
      return 0
    }
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth >= 481
      this.isMobile = window.innerWidth <= 480
    },
    selectThisBook() {
      this.selected = !this.selected

      if (this.selected) {
        this.$store.commit(UI_SELECT_BOOK, this.book.bookCd)
      } else {
        this.$store.commit(UI_UNSELECT_BOOK, this.book.bookCd)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .free_label {
//   background: #ffffff;
//   width: 32px;
//   height: 24px;
//   position: absolute;
//   box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
//   right: 0;
//   top: 0;
//   border-radius: 0px 6px;
//   text-align: center;
//   line-height: 24px;
//   color: #444444;
//   font-weight: 700;
//   font-size: 11px;
// }
// // 2022. 05. 13 추가 개발
.free_label {
  background: #36c2b5;
  height: 17px;
  position: absolute;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 30%);
  right: 0;
  top: 0;
  border-radius: 6px;
  text-align: center;
  line-height: 17px;
  color: #ffffff;
  font-weight: 500;
  font-size: 11px;
  padding: 0 4px;
  white-space: nowrap;
}
.vue-star-rating {
  width: 90px;
  float: left;
  top: 2px;
  position: relative !important;
}

.meta_rate {
  margin-top: 4px !important;
}

// // 학지CSS
// .h_cover_wrap {
//   width: 100%;
//   min-width: 160px;
//   max-width: 160px;
//   max-height: 224px;
//   position: relative;
//   box-shadow: 0 3px 3px rgb(36 84 179 / 30%);
//   overflow: hidden;
//   img {
//     width: 100%;
//     height: 100%;
//     display: inline-block;
//   }
//   .thum_wrap {
//     // position: absolute;
//     // top: 0;
//     // left: 0;
//     // display: inline-block;
//     width: 100%;
//     // height: 100%;
//   }
//   .thum_wrap::after {
//     position: absolute;
//     content: '';
//     display: block;
//     top: 0;
//     left: 0;
//     width: 4%;
//     min-width: 3px;
//     max-width: 20px;
//     height: 100%;
//     // background-color: rgba(0, 0, 0, 0.08);
//     background: linear-gradient(
//       to right,
//       rgba(0, 0, 0, 0.12) 60%,
//       rgba(0, 0, 0, 0.08),
//       transparent
//     );

//     mix-blend-mode: multiply;
//   }
// }
// .info_wrap {
//   text-align: left;
//   margin-top: 20px;
//   width: 71%;
//   max-width: 220px;
//   .meta_title {
//     text-align: left !important;
//   }
// }

// @media (max-width: 1280px) {
//   .info_wrap {
//     width: 100%;
//   }
// }

// @media (max-width: 515px) {
//   .info_wrap {
//     width: 71%;
//   }
// }
// 원격
.h_cover_wrap {
  width: 100%;
  min-width: 160px;
  max-width: 160px;
  // max-height: 224px;
  height: 244px;
  position: relative;
  // box-shadow: 0 3px 3px rgb(36 84 179 / 30%);
  // overflow: hidden;
  img {
    object-fit: fill;
    width: 100%;
    max-height: 224px;
    // height: 100%;
    display: inline-block;
  }
  .thum_wrap {
    // display: block;
    // position: absolute;
    // top: 0;
    // left: 0;
    // line-height: 1;
    line-height: 0;
    display: inline-block;
    width: 100%;
    box-shadow: 0 3px 3px rgb(36 84 179 / 30%);
    overflow: hidden;
    position: relative;
    // background-color: red;
    // ::before {
    //   content: '';
    //   box-shadow: 0 3px 3px rgb(36 84 179 / 30%);
    // }
    // height: 100%;
  }
  .thum_wrap::before {
    position: absolute;
    content: '';
    display: block;
    top: 0;
    left: 0;
    width: 4%;
    min-width: 3px;
    max-width: 20px;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.08);
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.12) 60%,
      rgba(0, 0, 0, 0.08),
      transparent
    );

    mix-blend-mode: multiply;
  }
}
.info_wrap {
  text-align: left;
  // margin-top: 20px;
  // width: 71%;
  max-width: 161px;
  .meta_title {
    text-align: left !important;
  }
}

@media (max-width: 1280px) {
  .info_wrap {
    width: 100%;
  }
}

@media (max-width: 515px) {
  .info_wrap {
    width: 71%;
  }
}
@media (max-width: 480px) {
  figure {
    margin: 0;
  }
  figcaption {
    b {
      display: block;
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 3px;
      color: #444444;
    }
    span {
      display: block;
      font-size: 9px;
      color: #848484;
    }
  }
  .book_link {
    display: block;
    width: 123px;
    height: 167px;
    margin-bottom: 7px;
    border: 1px solid #a5a4a4;
    border-radius: 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
}
</style>
